/**
 * 其知网 文章管理(其知学院)
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/index/index' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>其知学院</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.title" style="width:140px" placeholder="输入文章标题"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.author" style="width:140px" placeholder="输入文章作者"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.category" style="width:140px" placeholder="请选择">
          <el-option v-for="type in cateSearchArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.type" style="width:140px" placeholder="请选择">
          <el-option v-for="type in type" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <!-- 支付时间 -->
      <el-form-item>
        <el-date-picker v-model="formInline.start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择发布开始时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-date-picker v-model="formInline.end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择发布结束时间" :picker-options="pickerOptions"> </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">发布</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="danger" icon="el-icon-delete" @click="delAllNew">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="sort" align="center" label="排序值" width="80" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="title" align="center" label="文章标题" width="240" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="title" align="center" label="文章标题" width="240" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="封面图片" align="center" width="240" show-overflow-tooltip>
        <template slot-scope="scope">
        　  <img :src="scope.row.cover_img" width="80" height="80" class="head_pic"/>
        </template>
      </el-table-column>
      <el-table-column prop="author" align="center" label="文章作者" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="real_name" align="center" label="发布人" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="category_name" align="center" label="分类" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type_name" align="center" label="类型" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="发布时间" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="views" align="center" label="浏览量" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="180">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delNew(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="addTitle" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" ref="editForm" :model="editForm" :rules="addFormRules">
        <el-row>
            <el-form-item label="文章标题" prop="title">
              <el-input size="small" v-model="editForm.title" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="文章类型" prop="type">
                <el-radio-group type="kind" v-model="editForm.type" @change="changeType"> 
                    <el-radio v-model="editForm.type" :label="1" style="font-size: 25px">图文</el-radio>
                    <el-radio v-model="editForm.type" :label="2">视频</el-radio>
                    <el-radio v-model="editForm.type" :label="3">纯文字</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="文章分类" prop="category">
                <!-- <el-option v-for="type in cateArr" :label="type.key" :value="type.value" :key="type.value"></el-option> -->
              <el-select size="small" v-model="editForm.category" placeholder="请选择" @change="selectCate">
                <el-option v-for="type in cateArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文章封面" prop="cover_img">
              <el-upload
                class="avatar-uploader"
                action="https://zlbb.qzhip.com/index.php/index/base/uploadFile"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="editForm.cover_img" :src="editForm.cover_img" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
                <div v-if="isVideo" class="content">
                  <el-form-item label="上传视频" prop="content">
                  <el-upload
                    action
                    :http-request="Upload"
                    :before-upload="beforeAvatarVideoUpload"
                    :on-preview="handlePreview"
                    :before-remove="beforeRemove"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :on-exceed="handleExceed"
                    drag
                    :limit="limit"
                    :file-list="fileList"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                  </div>
                  <div slot="tip" class="el-upload__tip">1.上传过程中请不要关闭弹窗 2.上传文件大小不能超过 1G</div>
                </el-upload>

                <el-progress
                  v-show="showProgress"
                  :text-inside="true"
                  :stroke-width="15"
                  :percentage="progress"
                ></el-progress>
                </el-form-item>
                </div>
            <div v-else>
              <el-form-item label="文章内容" prop="content">
                <quill-editor ref="text" v-model="editForm.content" class="myQuillEditor" :options="editorOption" />
              </el-form-item>
            </div>

            <div v-if="isVideo">
              <div v-if="videoUrl">
                <el-form-item label="视频预览" prop="content">
                  <video width="380px" height="180px" controls>
                    <source :src=videoUrl type="video/mp4">
                  </video>
                </el-form-item>
              </div>
            </div>

            <el-form-item label="文章作者" prop="author">
              <el-input size="small" v-model="editForm.author" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="文章地址" prop="link">
              <el-input size="small" v-model="editForm.link" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="文章备注" prop="desc">
              <el-input size="small" v-model="editForm.desc" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="排序值" prop="sort">
              <el-input size="small" v-model="editForm.sort" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitEditNews('editForm')">发布</el-button>
              <el-button size="mini" @click='closeDialog("editForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { webCollegeList, webEditCollege, webDelCollege, webUrl , webCateList, webDelCheckCollege } from '../../api/webMG'
import Pagination from '../../components/Pagination'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

//引入富文本 start
import { quillEditor, Quill } from 'vue-quill-editor'
import { container, ImageExtend, QuillWatch } from 'quill-image-extend-module'
// import imageResize from 'quill-image-resize-module' // 引用，调整图片大小
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { checkLogin, getCurrentDate } from '../../utils/util'
import Video from '../video.vue'

Quill.register('modules/ImageExtend', ImageExtend)
// Quill.register('modules/imageResize', imageResize)
//引入富文本 end

// const apiUrl = "http://192.168.0.158/index.php";
const apiUrl = "https://zlbb.qzhip.com/index.php";
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {
      // 视频上传开始
      fileList: [],//文件列
      showProgress: false,//进度条的显示
      dataObj: {}, //存签名信息
      progress: 0, //进度条数据
      // 视频上传结束

      idShow: false,
      idCoverShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      dialogVisible: false, //控制预览图片显示与隐藏

      videoUrl: '',//视频地址

      isVideo: false,
      productImgs: [],
      dialogImageUrl: '',
      isMultiple: true,
      title: '用户详情',
      addTitle: '发布文章',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      editorOption: {
        placeholder: "",
        modules: {
          ImageExtend: {
            loading: true,
            name: "file", //图片参数名
            size: 1, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: "https://zlbb.qzhip.com/index.php/index/base/uploadFile", //上传的服务器地址，如果action为空，则采用base64插入图片
            // response 为一个函数，用来获取服务器返回的具体图片地址
            response: res => {
              console.log(res);
              const imgUrl = res.data.url;
              return imgUrl;
            },
            headers: xhr => {
              // 上传图片请求需要携带token的 在xhr.setRequestHeader中设置，这里我的token存放在sessionStorage中
              xhr.setRequestHeader(
                "Token",
                window.localStorage.getItem("token")
              );
            },
            // 可选参数 设置请求头部
            sizeError: () => {}, // 图片超过大小的回调
            start: () => {}, // 可选参数 自定义开始上传触发事件
            end: () => {}, // 可选参数 自定义上传结束触发的事件，无论成功或者失败
            error: () => {}, // 可选参数 上传失败触发的事件
            success: () => {
              console.log("ImageExtend中的success：上传成功");
            }, // 可选参数  上传成功触发的事件
            change: (xhr, formData) => {
              // xhr.setRequestHeader('myHeader','myValue')
              // formData.append('token', 'myToken')
            } // 可选参数 每次选择图片触发，也可用来设置头部，但比headers多了一个参数，可设置formData
          },
          // 调整图片大小
          // imageResize: {
					// 	displayStyles: {
					// 		backgroundColor: 'black',
					// 		border: 'none',
					// 		color: 'white'
					// 	},
					// 	modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
					// },
          // 如果不上传图片到服务器，此处不必配置
          toolbar: {
            // container为工具栏，此次引入了全部工具栏，也可自行配置
            container: [
              ['bold', 'italic', 'underline', 'strike'],// 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'],// 引用，代码块
              [{ 'header': 1 }, { 'header': 2 }], // 标题，键值对的形式；1、2表示字体大小
              [{ 'list': 'ordered' }, { 'list': 'bullet' }], // 列表
              [{ 'script': 'sub' }, { 'script': 'super' }], // 上下标
              [{ 'indent': '-1' }, { 'indent': '+1' }], // 缩进
              [{ 'direction': 'rtl' }], // 文本方向
              [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }], // 几级标题
              [{ 'color': [] }, { 'background': [] }], // 字体颜色，字体背景颜色
              [{ 'font': [] }], // 字体
              [{ 'align': [] }], // 对齐方式
              ['clean'], //清除字体样式
              ['link','image','video'] //上传图片、上传视频
            ],
            // 上传成功，回显图片（会进入如上面ImageExtend的各过程，返回<img src="http://xx.xx.xx.xx:xxxx/file/xxx.jpg">）
            handlers: {
              image: function() {
                // 劫持原来的图片点击按钮事件
                QuillWatch.emit(this.quill.id);
              }
            }
          }
        }
      },
      cateArr: [],
      cateSearchArr: [],
       type: [
        { key: '全部', value: 0 },
        { key: '图文', value: 1 },
        { key: '视频', value: 2 },
        { key: '纯文字', value: 3 }
      ],
      editForm: {
        id: '',
        title: '',
        author: '',
        content: '',
        category: '',
        type: '',
        cover_img: '',
        link: '',
        sort: '',
        desc: '',
        category_name: '',
        flag: '',
        duration: '',
      },
      formInline: {
        page: 1,
        ps: 10,
        start_time: '',
        end_time: '',
        title: '',
        author: '',
        type: 0,
        category: 0,
        // token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 表单验证
      addFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        author: [
          { required: true, message: '请输入作者', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择分类', trigger: 'blur' }
        ],
        cover_img: [
          { required: true, message: '请上传封面图', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择类型', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },

      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: "",
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      // videoForm: {
      //     showVideoPath: ''
      // } 
    }
  },
  // 注册组件
  components: {
    Pagination,
    quillEditor
  },
 
   /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getCate()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 视频上传oss 开始

     // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
      const isLt100M = file.size / 1024 / 1024 < 1024;
      // const isLt30 = file.name.length < 30;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小要小于1GB哦!");
        return false;
      }
      let videoUrl = URL.createObjectURL(file);
      let audioElement = new Audio(videoUrl);
      audioElement.addEventListener("loadedmetadata", () => {
      let duration = audioElement.duration; //时长为秒，小数，182.36
      that.editForm.duration = duration
      console.log(duration)
      });
      // if (!isLt30) {
      //   this.$message.error("上传视频文件名称长度必须要小于30个文字哦!");
      //   return false;
      // }
	  // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      // 前缀
      let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        let temporary = file.file.name.lastIndexOf(".");
        let fileNameLength = file.file.name.length;
        let fileFormat = file.file.name.substring(
          temporary + 1,
          fileNameLength
        );
        let fileName = getFileNameUUID() + "." + fileFormat;
        let currentDate = getCurrentDate(); 
        client(that.dataObj)
          .multipartUpload(`qzhip/video/${currentDate}/${fileName}`, file.file, {
            progress: function(p) {
              //p进度条的值
              console.log(p);
              that.showProgress = true;
              that.progress = Math.floor(p * 100);
            }
          })
          .then(result => {
            //上传成功返回值，可针对项目需求写其他逻辑
            //将视频url提取出来并赋值
            console.log(result);
            console.log(videoPrefix+result.name);
            let videoUrl = videoPrefix+result.name
            that.editForm.content = videoUrl
            that.videoUrl = videoUrl
            that.$message({
                type: 'success',
                message: '上传成功'
          })
          })
          .catch(err => {
            console.log("err:", err);
          });
      }
      multipartUpload();
    
    },
    // 视频上传oss 结束


    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webCollegeList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 获取当前年月
    
    // 获取分类
    getCate(){
        const cateParam = {type:3}
        webCateList(cateParam)
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.cateArr = res.data.cateOne
                  this.cateSearchArr = res.data.cateTwo
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 获取选中的分类
    selectCate(value){
      this.cateArr.forEach(item=>{
        if(item.value == value){
            this.editForm.category_name = item.key
            this.editForm.flag = item.flag
        }
      })
    },
    //显示编辑界面
    handleEdit: function(index, row){
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        if(row.type == 2){
          this.isVideo = true
        }else{
          this.isVideo = false
        }
        this.addTitle = '编辑文章'
        this.editForm.id = row.id,
        this.editForm.title = row.title,
        this.editForm.author = row.author,
        this.editForm.content = row.content,
        this.editForm.category = row.category,
        this.editForm.type = row.type,
        this.editForm.link = row.link,
        this.editForm.cover_img = row.cover_img,
        this.editForm.sort = row.sort,
        this.editForm.desc = row.desc,
        this.editForm.flag = row.flag
        if(this.isVideo){
            this.videoUrl = row.content
        }
      } else {
        this.addTitle = '发布文章'
        this.editForm.id = '',
        this.editForm.title = '',
        this.editForm.author = '',
        this.editForm.content = '',
        this.editForm.category = '',
        this.editForm.type = '',
        this.editForm.link = '',
        this.editForm.cover_img = '',
        this.editForm.sort = '',
        this.editForm.desc = '',
        this.editForm.flag = ''
        if(this.isVideo){
            this.videoUrl = ''
        }
      }

    },
    // 编辑页面保存方法
    submitEditNews(editData) {
      //校验参数
      this.$refs[editData].validate(valid => {
        if(valid){
          console.log(valid)
           webEditCollege(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.getCate()
                this.$message({
                  type: 'success',
                  message: '发布成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        }else{
          return false;
        }
      })
      
     
    },
    // 删除文章
    delNew(index, row) {
    // 添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
      const delParam = {id:row.id}
      webDelCollege(delParam)
      .then(res=>{
        this.loading = false
        console.log(res);
        res = checkLogin(res)
        if (res.code == 200) {
            this.$message({
                type: 'success',
                message: '删除成功'
          })
            this.getdata(this.formInline)
        } else {
            this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delAllNew(){
    // 判断是否有勾选的数据，没有提示
        const checkedArr = this.multipleSelection;
        const idsArr = [];
        checkedArr.forEach(function(item,index){
            idsArr.push(item.id)
        });
        if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
        }
        //添加提示框，确定后再导出，防止乱点，减轻服务器压力
      this.$confirm('确定删除所有勾选的吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        const idStr = JSON.stringify(idsArr)
        const delParam = {ids:idStr}
        webDelCheckCollege(delParam)
        .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
              this.$message({
                  type: 'success',
                  message: '删除成功'
            })
              this.getdata(this.formInline)
          } else {
              this.$message({
                  type: 'info',
                  message: res.msg
            })
          }
        })
        })
         .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 图片上传成功
    handleAvatarSuccess(res,file,fileList){
      if(res.code == 200){
        this.editForm.cover_img = res.data.url;
        this.$message({
            type: 'success',
            message: '上传成功'
          })
      }else{
        this.$message.error(res.msg);
      }
      console.log(res)
    },
    //文件上传之前调用做一些拦截限制
    beforeAvatarUpload(file) {
      const isJPG = true;
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    changeType(){
      if(this.editForm.type == 2){
        this.isVideo = true
      }else{
        this.isVideo = false
      }
      // console.log(this.editForm.type)
    },
     //上传前回调
    beforeUploadVideo(file) {
        var fileSize = file.size / 1024 / 1024 < 200;
        if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) == -1) {
            this.$message({
              type: 'error',
              message: '请上传正确的视频格式'
            })
            return false;
        }
        if (!fileSize) {
            this.$message({
                type: 'error',
                message: '视频大小不能超过200MB'
              })
            return false;
        }
        this.isShowUploadVideo = false;
    },
    //进度条
    uploadVideoProcess(event, file, fileList) {
        this.videoFlag = true;
        this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleVideoSuccess(res, file) {
        this.isShowUploadVideo = true;
        this.videoFlag = false;
        this.videoUploadPercent = 0;
      
        //后台上传地址
        if (res.code == 200) {
            this.editForm.content = res.data.url;
            this.$message({
                type: 'success',
                message: res.msg
              })
        } else {
            this.$message({
                type: 'error',
                message: res.msg
              })
        }
    },
    // 错误的回调
    ReferenceError(){

    },
    }
  }
</script>
<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/web/College.vue